import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 2 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", null, "From date", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", null, "To date", -1)
const _hoisted_4 = { key: 3 }

import { computed, reactive, PropType } from 'vue';
import { SInputDropdown, SDatePicker, SInputText } from '@simmons/components';
import useVuelidate, { ValidationArgs } from '@vuelidate/core';

import { FilterType } from '@/components/FilterPanel/FilterPanel.types';
import filterDatesValidations from '@/utils/validators/filterDates';


export default /*#__PURE__*/_defineComponent({
  props: {
  modelValue: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    type: [Array, String, Date, Object] as any,
    default: undefined,
  },
  type: {
    type: String as PropType<FilterType>,
    default: 'text',
  },
  options: {
    type: Array as PropType<Array<{ label: string; value: string; }>>,
    default: () => [],
  },
  tagLimit: {
    type: Number,
    required: false,
    default: 4,
  },
  search: {
    type: Boolean,
    required: false,
    default: true,
  },
  canSelectAll: {
    type: Boolean,
    required: false,
    default: true,
  },
},
  emits: ["update:modelValue", "filterDatesValidation"],
  setup(__props, { emit }: { emit: ({(event: 'update:modelValue', value: any): void,
  (event: 'filterDatesValidation', failed: boolean): void,
}), expose: any, slots: any, attrs: any }) {

const props = __props



// eslint-disable-next-line @typescript-eslint/no-explicit-any


const is = computed(() => ({
  select: props.type === 'select',
  selectMultiple: props.type === 'select-multiple',
  datepicker: props.type === 'datepicker',
  datetimeRangePicker: props.type === 'datetime-range-picker',
  input: props.type === 'input',
}));

const dates = reactive<{from: Date | null, to: Date | null}>({
  from: null,
  to: null,
});

const rules: ValidationArgs = {
  ...filterDatesValidations,
};

const validation = useVuelidate(rules, dates);

const value = computed({
  get: () => {
    const isUndefined = props.modelValue === undefined;
    // noinspection JSIncompatibleTypesComparison
    const isNull = props.modelValue === null;

    if (!(isUndefined || isNull)) {
      return props.modelValue;
    }

    if (is.value.select) {
      return undefined;
    }

    if (is.value.selectMultiple) {
      return [];
    }

    return undefined;
  },
  set: (v) => {
    emit('update:modelValue', v);
  },
});

const fromDate = computed({
  get: () => {
    const isUndefined = props.modelValue === undefined;
    // noinspection JSIncompatibleTypesComparison
    const isNull = props.modelValue === null;

    if (!(isUndefined || isNull)) {
      return props.modelValue.from;
    }

    if (is.value.datepicker || is.value.datetimeRangePicker) {
      return new Date();
    }

    return undefined;
  },
  set: (v) => {
    dates.from = v;
    emit('update:modelValue', dates);
    emit('filterDatesValidation', validation.value.$invalid);
  },
});

const toDate = computed({
  get: () => {
    const isUndefined = props.modelValue === undefined;
    // noinspection JSIncompatibleTypesComparison
    const isNull = props.modelValue === null;

    if (!(isUndefined || isNull)) {
      return props.modelValue.to;
    }

    if (is.value.datepicker || is.value.datetimeRangePicker) {
      return new Date();
    }

    return undefined;
  },
  set: (v) => {
    dates.to = v;
    emit('update:modelValue', dates);
    emit('filterDatesValidation', validation.value.$invalid);
  },
});

const handleSelectClear = () => {
  value.value = undefined;
};

return (_ctx: any,_cache: any) => {
  return (_unref(is).select || _unref(is).selectMultiple)
    ? (_openBlock(), _createBlock(_unref(SInputDropdown), {
        key: 0,
        modelValue: _unref(value),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : null)),
        options: __props.options,
        "can-select-all": __props.canSelectAll,
        search: __props.search,
        "tag-limit": __props.tagLimit,
        size: "mini",
        target: "body",
        onClear: handleSelectClear
      }, null, 8, ["modelValue", "options", "can-select-all", "search", "tag-limit"]))
    : (_unref(is).input)
      ? (_openBlock(), _createBlock(_unref(SInputText), {
          key: 1,
          modelValue: _unref(value),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(value) ? (value).value = $event : null)),
          size: "small"
        }, null, 8, ["modelValue"]))
      : (_unref(is).datepicker || _unref(is).datetimeRangePicker)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", null, [
              _hoisted_2,
              _createVNode(_unref(SDatePicker), {
                modelValue: _unref(fromDate),
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(fromDate) ? (fromDate).value = $event : null)),
                target: "body",
                name: "from",
                validation: _unref(validation),
                "show-time-picker": _unref(is).datetimeRangePicker
              }, null, 8, ["modelValue", "validation", "show-time-picker"])
            ]),
            _createElementVNode("div", null, [
              _hoisted_3,
              _createVNode(_unref(SDatePicker), {
                modelValue: _unref(toDate),
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(toDate) ? (toDate).value = $event : null)),
                target: "body",
                name: "to",
                validation: _unref(validation),
                "show-time-picker": _unref(is).datetimeRangePicker
              }, null, 8, ["modelValue", "validation", "show-time-picker"])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, " Unsupported filter type "))
}
}

})